import {isEmpty} from 'ramda';

import {Nullish} from 'shared/web';

import {WarehouseAccessRange, WarehouseAccessRow} from './getWarehouseAccessRows';

export type WarehouseAccessRangeFilter = WarehouseAccessRange | 'ALL';

export type IndexedWarehouseAccessRow = WarehouseAccessRow & {index: number};

/**
 * @about Keep the rows that match the search string (warehouse number or name) and the access range.
 * Each row keeps its index in the full list, because the form holds every warehouse and the PUT
 * sends them all: a hidden row must keep its value.
 * The access range filter compares the saved range, so a row does not disappear while it is edited.
 */
export const filterWarehouseAccessRows = (
  rows: WarehouseAccessRow[],
  searchString: string | Nullish,
  accessRangeFilter: WarehouseAccessRangeFilter
): IndexedWarehouseAccessRow[] => {
  const search = searchString?.trim().toLowerCase() ?? '';

  return rows
    .map((row, index) => ({...row, index}))
    .filter(
      (row) =>
        (accessRangeFilter === 'ALL' || row.accessRange === accessRangeFilter) &&
        (isEmpty(search) ||
          [row.warehouseNumber, row.warehouseName].some(
            (value) => value?.toLowerCase().includes(search) ?? false
          ))
    );
};
